import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CpoeService {

  constructor(private http: HttpClient) { }

  // ─── Lab Orders ──────────────────────────────────────────────────────────────

  addLabOrder(data: any): Observable<any> {
    return this.http.post(environment.addLabOrder, data);
  }

  getLabOrders(data: any): Observable<any> {
    return this.http.post(environment.getLabOrders, data);
  }

  updateLabOrder(data: any): Observable<any> {
    return this.http.post(environment.updateLabOrder, data);
  }

  // ─── Imaging Orders ───────────────────────────────────────────────────────────

  addImagingOrder(data: any): Observable<any> {
    return this.http.post(environment.addImagingOrder, data);
  }

  getImagingOrders(data: any): Observable<any> {
    return this.http.post(environment.getImagingOrders, data);
  }

  updateImagingOrder(data: any): Observable<any> {
    return this.http.post(environment.updateImagingOrder, data);
  }

  // ─── Medications (CPOE) ───────────────────────────────────────────────────────

  addMedication(data: any): Observable<any> {
    return this.http.post(environment.addMedication, data);
  }

  getMedications(data: any): Observable<any> {
    return this.http.post(environment.getMedications, data);
  }
}
